import { blackScholesModelCalculationService } from "../../BlackScholesModelCalculationService";
import { AssetType } from "../../../types/AssetType";
import { mathCalculationService } from "../../MathCalculationService";
import { PortfolioPositionModel } from "../../portfolio-positions-service/models/PortfolioPositionModel";
import { PortfolioGroupedItem } from "../../../../screens/positions-and-orders/models/PortfolioGroupedItem";

export abstract class BasePortfolioPositionsCalculationService {
    calculateAtCurrent(portfolioPositions: PortfolioGroupedItem[], underlyingPrice: number): number {
        let value = 0;

        portfolioPositions.map(item => {
            const timeToExpirationInShareOfYear = item.expireAt !== null
                ? blackScholesModelCalculationService.getTimeToExpirationInShareOfYear(item.expireAt)
                : null;
            
            value += this.calculate(item, underlyingPrice, timeToExpirationInShareOfYear, x => x.impliedVolatility!);
        });

        return value;
    }

    calculateAtCustom(
        portfolioPositions: PortfolioGroupedItem[],
        underlyingPrice: number,
        customDate: Date,
        getImpliedVolatility: (position: PortfolioGroupedItem) => number,
    ): number {
        let value = 0;

        portfolioPositions.map(item => {
            const timeToExpirationInShareOfYear = item.expireAt !== null
                ? blackScholesModelCalculationService.getTimeToExpirationInShareOfYear(item.expireAt, customDate)
                : null;
            
            value += this.calculate(item, underlyingPrice, timeToExpirationInShareOfYear, getImpliedVolatility);
        });

        return value;
    }

    calculateAtExpiration(portfolioPositions: PortfolioGroupedItem[], underlyingPrice: number): number {
        let value = 0;

        portfolioPositions.map(item => {
            value += this.calculate(item, underlyingPrice, this.getMinTimeToExpirationInShareOfYear(), x => x.impliedVolatility!);
        });

        return value;
    }

    calculate(
        position: PortfolioGroupedItem,
        underlyingPrice: number,
        timeToExpirationInShareOfYear: number | null,
        getImpliedVolatility: (position: PortfolioGroupedItem) => number,
    ): number {
        if (position.type === AssetType.Futures || position.type === AssetType.Spot) {
            return this.calculateForFutures(position);
        } else if (position.type === AssetType.Call || position.type === AssetType.Put) {
            if (timeToExpirationInShareOfYear === null) {
                throw new Error("Arg 'timeToExpirationInShareOfYear' is null.")
            }

            return this.calculateForOption(position, underlyingPrice, timeToExpirationInShareOfYear, getImpliedVolatility) * position.currentSize;
        }

        throw new Error("Unknown AssetType");
    }
    
    protected abstract calculateForFutures(position: PortfolioGroupedItem): number;

    protected abstract calculateForOption(
        position: PortfolioGroupedItem,
        underlyingPrice: number,
        timeToExpirationInShareOfYear: number,
        getImpliedVolatility: (position: PortfolioGroupedItem) => number,
    ): number;

    protected getMinTimeToExpirationInShareOfYear(): number {
        return 0;
    }

    protected round(value: number, precision: number): number {
        return mathCalculationService.round(value, precision);
    }
}